import { ActionTypes as action } from "./action-types";
import documentService from "../../../api/documentService";

const actions = {
    async getDocumentsList({ commit }) {
        const data = await documentService.getDocumentsList();
        commit(action.GET_DOCUMENT_LIST, data);
        return
    },
    async getDocumentsById({ commit }, id) {
        const data = await documentService.getDocumentsById(id);
        commit(action.GET_DOCUMENT_BY_ID, data);
        return
    },
    async createDocuments({ commit }, data) {
        const result = await documentService.createDocuments(data);
        return result
    },
    async createChatDocuments({ commit }, data) {
        const result = await documentService.createChatDocuments(data);
        return result
    },

    async deleteDocuments({ commit }, id) {
        await documentService.deleteDocuments(id);
        return
    },
    async getDocumentsByMeetingId({ commit }, id) {
        const data = await documentService.getDocumentsByMeetingId(id);
        return data
    },
    async getDocumentsByAgendaId({ commit }, id) {
        const data = await documentService.getDocumentsByAgendaId(id);
        return data
    },
    async getAgendaListForDocument({ commit }) {
        const data = await documentService.getAgendaListForDocument();
        commit(action.GET_AGENDA_LIST_FOR_DOCUMENT, data);
        return
    },
    async getMeetingListForDocument({ commit, state, rootState }, isFilterApply = true) {
        let filter = null;
        if (isFilterApply) {
            filter = rootState.meeting.default_meetting_filter
        }
        const data = await documentService.getMeetingListForDocument(filter);
        commit(action.GET_MEETING_LIST_FOR_DOCUMENT, data);
        return
    },
    async downloadDocument({ commit }, params) {
        const res = await documentService.downloadDocument(params.documentId, params.filename);
        return res
    },

    async getMeetingDocumentViews({ commit }, params) {
        const data = await documentService.getMeetingDocumentViews(params.meeting_id, params.user_email);
        commit(action.GET_MEETING_VIEWS, data);
        return
    },
    addDocumentView({ commit }, data) {
        commit(action.ADD_MEETING_VIEWS, data);
        return
    },
    async getLandingPageDocumentsList({ commit }) {
        const data = await documentService.getLandingPageDocumentsList();
        commit(action.GET_LANDING_PAGE_DOCUMENTS_LIST, data);
        return
    },
    async getLandingPageDocumentById({ commit }, id) {
        const data = await documentService.getLandingPageDocumentById(id);
        commit(action.GET_LANDING_PAGE_DOCUMENT_BY_ID, data);
        return data
    },
    async createLandingPageDocument({ dispatch }, data) {
        const result = await documentService.createLandingPageDocument(data);
        dispatch('getLandingPageDocumentsList')
        return result
    },
    async updateLandingPageDocument({ dispatch }, data) {
        const result = await documentService.updateLandingPageDocument(data);
        dispatch('getLandingPageDocumentsList')
        return result
    },
    async deleteLandingPageDocument({ commit }, id) {
        const result = await documentService.deleteLandingPageDocument(id);
        if (Boolean(result)) {
            commit(action.REMOVE_DOCUMENT_BY_ID, id);
        }

        return result
    },
    resetState({ commit }) {
        commit(action.RESET_STATE);
    },
};

export default actions;
